export {LinkInterceptor} from './LinkInterceptor'
